/**
 * Configurazione autenticazione JWT per ambiente.
 * L'ambiente è determinato solo da REACT_APP_ENV (build/start).
 * REACT_APP_ENV=azure-dev → DEV (JWT + can-import). REACT_APP_ENV=production → PROD.
 * Altrimenti → development (nessun check JWT).
 */

/**
 * Configurazione per ambiente DEV (REACT_APP_ENV=azure-dev).
 */
const DEV_AUTH = {
  jwtUrl: 'https://accounts.dev.basic.net/account/GetBasicJwtToken',
  unauthorizedRedirectUrl: 'https://my.dev.basic.net/error/unauthorized',
};

/**
 * Configurazione per ambiente PROD (REACT_APP_ENV=production / build di produzione).
 */
const PROD_AUTH = {
  jwtUrl: 'https://accounts.basic.net/account/GetBasicJwtToken',
  unauthorizedRedirectUrl: 'https://my.basic.net/error/unauthorized',
};

/**
 * Restituisce l'ambiente risolto: 'development' | 'azure-dev' | 'production'.
 * Solo REACT_APP_ENV (build/start): nessun hostname, nessun NODE_ENV.
 */
const getResolvedEnv = () => {
  const reactEnv = process.env.REACT_APP_ENV;
  if (reactEnv === 'azure-dev' || reactEnv === 'production') {
    return reactEnv;
  }
  return 'development';
};

/**
 * Restituisce true se l'app è in esecuzione in locale (nessun check JWT).
 * Equivale a ambiente "development" (build/start locale).
 */
export const isLocalEnvironment = () => {
  return getResolvedEnv() === 'development';
};

/**
 * Restituisce la configurazione auth per l'ambiente corrente.
 * - isLocal: true per development (REACT_APP_ENV=development o non impostato in locale).
 * - jwtUrl e unauthorizedRedirectUrl: definiti per azure-dev (DEV) e production (PROD).
 */
export const getAuthConfig = () => {
  const env = getResolvedEnv();

  if (env === 'development') {
    return {
      isLocal: true,
      jwtUrl: null,
      unauthorizedRedirectUrl: null,
    };
  }

  if (env === 'azure-dev') {
    return {
      isLocal: false,
      ...DEV_AUTH,
    };
  }

  return {
    isLocal: false,
    ...PROD_AUTH,
  };
};
